"use client"

import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { reatomComponent } from "@reatom/react"
import { CollectionNavigationReatom } from "../navigation/index.reatom"
import { CollectionOverviewReatom } from "../overview/overview.reatom"
import { CollectionOverviewSkeletonReatom } from "../overview/view/index.reatom"
import {
  StatisticReatom,
  StatisticSkeletonReatom,
} from "../statistic/statistic.reatom"

interface Props {
  collectionId: CollectionId
}

export const CollectionHeaderReatom = reatomComponent<Props>((props) => {
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4 overflow-hidden px-4 pb-3 md:px-8 md:pb-[22px]">
        <CollectionOverviewReatom />
        <StatisticReatom />
      </div>
      <CollectionNavigationReatom collectionId={props.collectionId} />
    </>
  )
}, "CollectionHeaderReatom")

export function CollectionHeaderSkeletonReatom() {
  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 overflow-hidden px-4 pb-3 md:px-8 md:pb-[22px]">
        <CollectionOverviewSkeletonReatom />
        <StatisticSkeletonReatom />
      </div>
      <div className="h-[theme('spacing.collection-navigation-height')]" />
    </div>
  )
}
